<template>
  <div class="page-frame" :class="[container ? 'page-container' : 'page-wrap']">
    <main class="wrap">
      <slot v-if="!loading" />
      <template v-else>
        <el-skeleton style="margin: 24px" />
        <el-skeleton style="margin: 24px" />
      </template>
    </main>
    <slot name="footer" />
  </div>
</template>

<script>
export default {
  name: 'PageFrame',
  props: {
    container: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    topOffset: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  height: 100%;
  .wrap {
    padding: 0;
    overflow-y: auto;
  }
}
.page-wrap {
  // height: calc(100vh - 110px);
  height: 100vh;
  .wrap {
    padding: 24px;
    overflow-y: auto;
  }
}
.page-frame {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
